import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const COOKIE_SECTIONS = [
  {
    title: "What Are Cookies",
    body: "Cookies are small text files placed on your device to help the app remember your preferences, cart state, and session details.",
  },
  {
    title: "How We Use Cookies",
    body: "We use cookies and local storage to keep you logged in, save your cart, improve performance, and understand usage patterns for better service.",
  },
  {
    title: "Types of Cookies",
    items: [
      "Essential: Required for login, checkout, and security.",
      "Preference: Saves language, address, and UI choices.",
      "Performance: Helps us understand app speed and reliability.",
    ],
  },
  {
    title: "Managing Cookies",
    body: "You can clear cookies from your browser settings anytime. Some core features like login and cart restore may stop working after clearing.",
  },
  {
    title: "Contact",
    body: "For cookie-related questions, contact us at shreejisurtiswad@gmail.com.",
  },
];

export default function Cookie() {
  return (
    <div className="home legal-page">
      <Navbar />

      <div className="customer-page legal-content-wrap">
        <div className="customer-page-header legal-hero">
          <h2>Cookie Policy</h2>
          <p>Last Updated: March 2026</p>
        </div>

        {COOKIE_SECTIONS.map((section) => (
          <section className="customer-card settings-section legal-section" key={section.title}>
            <h3>{section.title}</h3>
            {section.body && <p>{section.body}</p>}
            {section.items && (
              <ul className="legal-list">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>

      <Footer />
    </div>
  );
}
